import { httpClient } from '@/infra/protocols/http';

export function uploadAttachedFile(params: UploadAttachedFileService.Params) {
  return httpClient.get<UploadAttachedFileService.Response>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro/arquivo/${params.name}/upload`,
  );
}

export namespace UploadAttachedFileService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
    name: string;
  }

  export type Response = {
    nome: string;
    evento: string;
    idPodcast: number;
    idProjeto: number;
    idRoteiro: number;
    idUsuario: number;
    idEpisodio: number;
    presignedUrl: string;
  };
}
